/* CHERI ART GALLERY — LOCKED STANDARD V18 — STACKED COLLECTION
   Collection layout is CSS grid; no justified resizing is used.
   This file only handles filters/sort UI safely.
*/
(function () {
  function initCollection(root) {
    if (!root || root.dataset.acLockedReady === 'true') return;
    root.dataset.acLockedReady = 'true';

    var form = root.querySelector('[data-art-filters]');
    var toggle = root.querySelector('[data-filter-toggle]');
    var groups = root.querySelector('[data-filter-groups]');

    if (toggle && groups) {
      toggle.addEventListener('click', function () {
        var open = groups.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    if (form) {
      form.querySelectorAll('[data-auto-submit]').forEach(function (control) {
        control.addEventListener('change', function () {
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.submit();
        });
      });
    }
  }

  document.querySelectorAll('[data-art-collection]').forEach(initCollection);
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-art-collection]') : null;
    if (root) initCollection(root);
  });
})();
